import script from "./FirmaDetayScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./FirmaDetayScreen.vue?vue&type=script&setup=true&lang=js"

import "./FirmaDetayScreen.vue?vue&type=style&index=0&id=00610d24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00610d24"]])

export default __exports__